/**
 * Maximum number of sections to expand by default when rendering a report.
 * Reports with more sections than this will only expand the first N sections
 * to prevent the browser from freezing due to simultaneous heavy Markdown rendering.
 */
export const MAX_INITIALLY_EXPANDED_SECTIONS = 10;

/**
 * Number of leading sections whose content is treated as immediately visible
 * on mount, bypassing the IntersectionObserver. This avoids the issue where
 * the Radix Accordion open-animation (height 0 → auto with overflow:hidden)
 * prevents the observer from firing for sections already in the viewport.
 */
export const INITIAL_VISIBLE_SECTION_COUNT = 3;

/**
 * Returns the list of section IDs that should be initially expanded.
 * If the total number of sections exceeds MAX_INITIALLY_EXPANDED_SECTIONS,
 * only the first N sections are expanded to prevent browser performance issues.
 */
export function getInitialExpandedSections(allSectionIds: string[]): string[] {
  if (allSectionIds.length <= MAX_INITIALLY_EXPANDED_SECTIONS) {
    return allSectionIds;
  }
  return allSectionIds.slice(0, MAX_INITIALLY_EXPANDED_SECTIONS);
}
